import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatJackpot',
  standalone: true,
})
export class FormatJackpot implements PipeTransform {
  transform(fullValue: string): string {
    if (!fullValue) return ''; // Handle empty input

    const match = fullValue.match(/^(?<prefix>\D*)(?<number>[0-9.]+)(?<suffix>\D*)$/);
    if (!match?.groups) return fullValue; // Return original value if parsing fails

    const { prefix, number, suffix } = match.groups;
    const roundedValue = Math.round(Number(number))

    return `${prefix}${roundedValue}${suffix}`; // Reconstruct the formatted string
  }
}
